import * as React from 'react';
import { Box, Typography } from '@mui/material';

interface KpiItem {
    value: string | number;
    label: string;
}

interface KpiBoxProps {
    title: string;
    items: KpiItem[];
    accentColor?: string;
}

/**
 * Reusable KPI Box component for displaying grouped metrics
 * Shows a title and a horizontal list of value/label pairs
 * Optionally displays a vertical accent bar on the left side
 */
const KpiBox: React.FC<KpiBoxProps> = ({ title, items, accentColor }) => {
    return (
        <Box
            sx={{
                padding: '10px 12px',
                border: '1px solid #e0e0e0',
                borderRadius: '8px',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
                ...(accentColor && {
                    borderLeft: `4px solid ${accentColor}`,
                }),
            }}
        >
            <Typography variant="caption" color="textSecondary" sx={{ mb: 1, fontWeight: 600, display: 'block' }}>
                {title}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
                {items.map((item, index) => (
                    <Box key={index} sx={{ textAlign: 'center' }}>
                        <Typography variant="h3" fontWeight="bold" color="primary" fontSize="20px">
                            {item.value}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" display="block" noWrap>
                            {item.label}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default KpiBox;
